import { selectThemeStyle } from '../../../features/setting/setting.slice.ts'
import { useAppSelector } from '../../../redux/hooks.ts'
import { convertPxToNumber, isV2Ready } from '../../../utils/helpers.ts'
import { IdeyaButton } from '../../../common/antd/ideya-button.tsx'
import Col from 'antd/es/grid/col'
import Row from 'antd/es/grid/row'

interface FirmManagementUserControlsProps {
  onCreateFirm: () => void
}

export const FirmManagementUserControls: React.FC<
  FirmManagementUserControlsProps
> = ({ onCreateFirm }) => {
  const themeStyle = useAppSelector(selectThemeStyle)

  return (
    <Row
      align={'bottom'}
      justify={'space-between'}
      style={{ marginBottom: themeStyle.marginSM }}
    >
      <Col>
        {isV2Ready && (
          <Row
            gutter={[
              convertPxToNumber(themeStyle.marginXS),
              convertPxToNumber(themeStyle.marginXS),
            ]}
          >
            <Col>
              <IdeyaButton ideyaType={'secondary'}>Expand All</IdeyaButton>
            </Col>
            <Col>
              <IdeyaButton ideyaType={'secondary'}>Collapse All</IdeyaButton>
            </Col>
          </Row>
        )}
      </Col>
      <Col>
        <IdeyaButton onClick={onCreateFirm}>Add Firm</IdeyaButton>
      </Col>
    </Row>
  )
}
